import React from 'react';
import {
  Box,
  GDSStyleObject,
  HeadingText,
  queryHelpers,
  StackLayout,
  useMediaQuery,
  UtilityText,
} from '@leagueplatform/genesis-core';

export function COBLayout(props: any) {
  const {
    children,
    title,
    dataTestId,
    questionTitle,
    disclaimer,
    dependantSize,
    isDependant,
  } = props;
  const isHeight786 = useMediaQuery('(max-height:786px)');
  const isBelow380 = useMediaQuery(queryHelpers.down(380));

  const setHeight = () => {
    let heightValue = '';
    switch (isDependant) {
      case true:
        heightValue = dependantSize > 4 ? 'auto' : '663px';
        break;
      case false:
        heightValue = isHeight786 ? 'auto' : '690px';
        break;
      default:
        heightValue = 'auto';
        break;
    }
    return heightValue;
  };

  return (
    <StackLayout
      horizontalAlignment="center"
      css={
        {
          backgroundColor: 'White',
          maxWidth: '476px',
          borderRadius: '9px',
          minHeight: '663px',
          '@mobile': { height: setHeight() },
          '@laptop': { height: setHeight() },
          '@mobileLandscape': { height: setHeight() },
          '@tablet': { height: setHeight() },
        } as GDSStyleObject
      }
      data-testid={dataTestId}
    >
      <Box
        css={
          {
            display: 'flex',
            flexDirection: 'column',
            padding: '$twoAndHalf $three',
            '@mobile': {
              padding: '$twoAndHalf $threeQuarters',
            },
          } as GDSStyleObject
        }
      >
        <Box
          css={
            {
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            } as GDSStyleObject
          }
        >
          <Box
            css={
              {
                backgroundColor: '$surfaceBackgroundSecondary',
                borderRadius: '4px',
                color: '$onSurfaceTextSubdued',
                fontSize: '12px',
                textAlign: 'center',
                padding: '3px 10px',
                fontWeight: '$semibold',
              } as GDSStyleObject
            }
            aria-label={title}
          >
            {title}
          </Box>
        </Box>
        <Box
          css={
            {
              marginTop: '$one',
              maxWidth: isBelow380 ? '332px' : '368px',
            } as GDSStyleObject
          }
        >
          <HeadingText
            level="3"
            size={{
              '@initial': 'xl',
              '@mobile': 'xl',
              '@mobileLandscape': 'xl',
              '@tablet': 'xl',
              '@laptop': 'xl',
              '@desktop': 'xl',
            }}
            css={
              {
                marginTop: '$half',
                marginBottom: '$oneAndHalf',
                lineHeight: '30px',
              } as GDSStyleObject
            }
            aria-label={questionTitle}
            id="hasOtherInsuranceTitle"
          >
            {questionTitle}
          </HeadingText>
        </Box>
        <Box
          css={
            {
              marginBottom: '$two',
              maxWidth: isBelow380 ? '332px' : '368px',
            } as GDSStyleObject
          }
        >
          <UtilityText aria-label={disclaimer}>{disclaimer}</UtilityText>
        </Box>
        {children}
      </Box>
    </StackLayout>
  );
}
